import React, { useEffect, useState } from "react";
import Filter from "../../../../assets/Icons/filter.png";
import ExcelExport from "../../../../compnenets/commons/xls";
import Modal from "react-responsive-modal";
import Close from "../../../../assets/Images/close.png";
import leftArrow from "../../../../assets/Images/left-arrow.png";
import rightArrow from "../../../../assets/Images/right-arrow.png";
import "../archival.css";
import { PROJECT_ARCHIVAL } from "../../../../services/apiCalls/archivalApiCalls";
import PdfIcon from "../../../../assets/Icons/Pdf_Icon.png";
import DownloadIcon from "../../../../assets/Icons/Download_Icon.png";

export default function Concequences({ project }) {
  const [open, setOpen] = useState(false);
  const onOpenModal = () => setOpen(true);
  const [consequencesData, setConsequencesData] = useState([]);
  const [filterData, setFilterData] = useState({
    ProjectID: project.project_id,
    StartDate: "",
    EndDate: "",
    LO_LI_ID: "",
    sortOrder: "ASC",
    sortBy: "Site Vist/Audit Date",
  });

  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  const totalPages = Math.ceil(consequencesData.length / rowsPerPage);

  const handleClick = (page) => {
    setCurrentPage(page);
  };

  const paginatedData = consequencesData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );
  const fetchArchivalConsequences = async (payload) => {
    let obj = payload;
    if (!payload) {
      obj = {
        ProjectID: project.project_id,
      };
    }
    const response = await PROJECT_ARCHIVAL.Get_ConsequenceManagement(obj);
    if (response && response.ConsequenceManagementList?.length > 0) {
      setConsequencesData(response.ConsequenceManagementList);
    } else {
      setConsequencesData([]);
    }
  };
  useEffect(() => {
    fetchArchivalConsequences();
  }, []);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilterData((prev) => ({ ...prev, [name]: value }));
  };
  const downloadFile = (fileUrl) => {
    const link = document.createElement("a");
    link.href = fileUrl;
    console.log(fileUrl?.split("/").pop());
    link.setAttribute("download", fileUrl?.split("/").pop());
    // link.download = decodeURIComponent(fileUrl?.split('/').pop());
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  function truncateFileNameFromPath(fileName, maxLength) {
    const dotIndex = fileName.lastIndexOf(".");
    if (dotIndex === -1) {
      return fileName;
    }

    const name = fileName.substring(0, dotIndex);
    const extension = fileName.substring(dotIndex);

    if (fileName.length > maxLength) {
      const visibleLength = maxLength - 1 - extension.length;
      const startLength = Math.ceil(visibleLength / 2);
      const endLength = Math.floor(visibleLength / 2);
      const truncatedName = `${name.substring(
        0,
        startLength
      )}...${name.substring(name.length - endLength)}`;
      return `${truncatedName}${extension}`;
    }

    return fileName;
  }
  return (
    <React.Fragment>
      <Modal open={open} onClose={() => {}} center>
        <div className="d-flex justify-content-between">
          <div>
            <span className="resources">Consequence Management Filter</span>
          </div>
          <div>
            <img
              src={Close}
              width={20}
              onClick={() => setOpen(false)}
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="card mt-0 card-bd-none">
            <div className="card-body">
              <div className="row mt-1">
                <div className="col-6">
                  <label className="filter-label">Start Date</label>
                  <input
                    type="date"
                    name="StartDate"
                    value={filterData.StartDate}
                    onChange={handleChange}
                    className="form-control shadow-none"
                  />
                </div>
                <div className="col-6">
                  <label className="filter-label">End Date</label>
                  <input
                    type="date"
                    name="EndDate"
                    value={filterData.EndDate}
                    onChange={handleChange}
                    className="form-control shadow-none"
                  />
                </div>
              </div>

              <div className="row mt-1">
                <div className="col-12">
                  <label className="filter-label">LO/LI ID</label>
                  <input
                    type="text"
                    name="LO_LI_ID"
                    value={filterData.LO_LI_ID}
                    onChange={handleChange}
                    className="form-control shadow-none"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-3">
          <div className="d-flex justify-content-between">
            <div style={{ marginLeft: 20 }}>
              <span className="resorces">Sort Consequence Management</span>
            </div>
            <div style={{ marginRight: 20 }}>
              <select
                name="sortOrder"
                value={filterData.sortOrder}
                onChange={handleChange}
                className="filter-label"
                style={{
                  width: "100%",
                  height: 31,
                  border: "1px solid #e6e3e3",
                  borderRadius: 4,
                }}
              >
                <option value="ASC">ASC</option>
                <option value="DES">DES</option>
              </select>
            </div>
          </div>
        </div>
        <div className="row" style={{ marginLeft: 20 }}>
          {["Created date"].map((sortOption) => (
            <div className="form-check" key={sortOption}>
              <input
                className="form-check-input shadow-none"
                type="radio"
                name="sortBy"
                id={sortOption}
                value={sortOption}
                checked={filterData.sortBy === sortOption}
                onChange={handleChange}
              />
              <label htmlFor={sortOption} style={{ fontSize: 14 }}>
                {sortOption}
              </label>
            </div>
          ))}
        </div>

        <div className="d-flex justify-content-center mt-4 pb-4">
          <button
            className="btn btn-primary"
            onClick={() => {
              fetchArchivalConsequences(filterData);
              setOpen(false);
              setCurrentPage(1);
            }}
          >
            Filter
          </button>
        </div>
      </Modal>
      <div className="row">
        <div className="d-flex justify-content-end">
          <div className="download-icon">
            <ExcelExport
              data={consequencesData}
              fileName="Consequences"
              sheet="Consequences List"
            />
          </div>
          <div className="filter-icon mx-2 my-auto">
            <img
              className=""
              onClick={() => {
                setOpen(true);
              }}
              src={Filter}
              width={20}
            />
          </div>
          <div className="my-auto" onClick={() => fetchArchivalConsequences()}>
            <span
              style={{
                cursor: "pointer",
                fontSize: 12,
                fontWeight: 500,
                background: "#8add79f7",
                padding: 5,
                borderRadius: 12,
              }}
            >
              Clear filters
            </span>
          </div>
        </div>
      </div>
      <div className="table-container-archival">
        <table id="custom-table-archival">
          <thead className="table-header-archival">
            <tr>
              <th>Sr No</th>
              <th>LO/LI ID</th>
              <th>Project Name</th>
              <th>Location</th>
              <th>Product Category</th>
              <th>Penalty Imposed</th>
              <th>Upload Document</th>
              <th>Created Date</th>
            </tr>
          </thead>
          <tbody>
            {paginatedData.map((row, index) => (
              <tr key={index}>
                <td>{index + 1 + (currentPage - 1) * 10}</td>

                <td>{row.LO_LI_ID}</td>
                <td>{row.ProjectName}</td>
                <td>{row.Location}</td>
                <td>{row.Product_Category}</td>
                <td>
                  <input
                    type="checkbox"
                    disabled
                    checked={row.Penalty_Imposed == "YES" ? true : false}
                  />
                </td>
                <td>
                  {row.Upload_Document1 != "" &&
                  row.Upload_Document1 != null ? (
                    <>
                      <img
                        src={PdfIcon}
                        alt="PDF Icon"
                        style={{ width: "16px", marginRight: "8px" }}
                      />
                      {truncateFileNameFromPath(
                        decodeURIComponent(
                          row.Upload_Document1.split("/").pop()
                        ),
                        15
                      )}
                      <img
                        src={DownloadIcon}
                        alt="Download Icon"
                        style={{
                          width: "16px",
                          marginLeft: "8px",
                          cursor: "pointer",
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          downloadFile(row.Upload_Document1);
                        }}
                      />
                    </>
                  ) : (
                    <>-</>
                  )}
                </td>
                <td>{new Date(row?.CreatedOn).toLocaleDateString('en-GB')}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div
        className="pagination"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "10px 15px",
        }}
      >
        <div style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
          Showing{" "}
          {Math.min(
            (currentPage - 1) * rowsPerPage + 1,
            consequencesData.length
          )}{" "}
          to {Math.min(currentPage * rowsPerPage, consequencesData.length)} of{" "}
          {consequencesData.length} entries
        </div>

        <div
          className="pagination-buttons"
          style={{
            fontSize: "14px",
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
            gap: "5px",
          }}
        >
          {/* Left Arrow */}
          <button
            onClick={() => handleClick(Math.max(1, currentPage - 1))}
            disabled={currentPage === 1}
            style={{
              background: "none",
              border: "none",
              cursor: currentPage === 1 ? "not-allowed" : "pointer",
            }}
          >
            <img
              src={leftArrow} // Replace with your actual image path
              alt="Previous"
              height="11px"
              width="7px"
              style={{ opacity: currentPage === 1 ? 0.5 : 1 }}
            />
          </button>

          {/* Page Numbers */}
          {[...Array(totalPages)].map((_, i) => (
            <button
              key={i}
              onClick={() => handleClick(i + 1)}
              style={{
                background: currentPage === i + 1 ? "#00B69B" : "transparent",
                color: currentPage === i + 1 ? "#fff" : "#000",
                border: "none",
                borderRadius: "50%",
                width: "30px",
                height: "30px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
            >
              {i + 1}
            </button>
          ))}

          {/* Right Arrow */}
          <button
            onClick={() => handleClick(Math.min(totalPages, currentPage + 1))}
            disabled={currentPage === totalPages}
            style={{
              background: "none",
              border: "none",
              cursor: currentPage === totalPages ? "not-allowed" : "pointer",
            }}
          >
            <img
              src={rightArrow} // Replace with your actual image path
              alt="Next"
              height="11px"
              width="7px"
              style={{ opacity: currentPage === totalPages ? 0.5 : 1 }}
            />
          </button>
        </div>
      </div>
    </React.Fragment>
  );
}
